import React, { Fragment } from 'react';
import Banner from '../../prelogin/src/components/Banner';
import UserLoginType from './ng_UserLoginType';
import Whatsapp from '../login/Whatsapp.js';
import ModalVideo from 'react-modal-video';

/*
* This class is merely an extension of the previous banner
*
*/
export default class ng_Banner extends Banner {
	callregisterform = () => {
		window.open(this.getUrlFor("ZA_FACEBOOKEVENT_REGISTRATIONFORM"), "_blank")
	}
	openpdfform = () => {
		window.open(this.getUrlFor("ZA_FACEBOOKEVENT_PDFLINK"), "_blank")
	}

	getFaceBookEventUIWeb() {
		if (window.facebookEventAvailForNG) {
			return (
				<Fragment>
					<div className="heading-one robotospan headerpart2">
						<span className="txtcnt first-line">{this.rb("banner.subheading1.za5")}</span>
					</div>
					<div className="text-link text-center registerbtncontain">
						<span onClick={this.callregisterform} className="txtcnt furtxt registerbtn" >{this.rb("banner.subheading1.za6")}</span>
					</div>
					<div className="heading-one robotospan headerpart3">
						<span className="txtcnt furtxt">{this.rb("banner.subheading1.za7")}</span>
						<img onClick={this.openpdfform} src="/img/facebook.png" alt="" />
					</div>
				</Fragment>
			)
		} else {
			return (
				<div className="heading-one robotospan" id="robotoheading" style={{ textAlign: 'center', marginTop: '20px' }}>
					<span className="txtcnt first-line txtsubhead1" style={{ fontSize: '20px !important', fontFamily: 'Roboto !important' }}>{this.rb("banner.subheading1.ng3")}</span>
					<span className="txtcnt furtxt txtsubhead2" style={{ fontSize: '20px !important', fontFamily: 'Roboto !important' }}>{this.rb("banner.subheading1.ng4")}</span>
				</div >
			)
		}
	}

	homeforweb() {

		return (
			<div className="slider-inner b-web-comp za-banner" style={{ padding: '40px 0px' }}>
				<div className="col-12 b-right" style={{ display: 'none' }}>
					<div className="r-banner">
						<img src="../img/banner1.png" alt="" onClick={this.openModal} />
						<a data-ga="Home  - Hey Parent Video" className="popup-modal" onClick={this.openModal}><span className="play-btn"></span></a>
					</div>
				</div>
				<div className="col-12">

					<h1 className="heading-one" style={{ textAlign: 'center' }}>
						<span className="txtcnt first-line" style={{ fontSize: '32px' }}>{this.rb("banner.heading.ng2")}</span>
						<span className="txtcnt furtxt" style={{ fontSize: '32px' }}>{this.rb("banner.subheading.ng2")}</span>
					</h1>
					{/* <h1 className="heading-one" style={{ textAlign: 'center', marginBottom: '20px' }}>
						<span className="txtcnt furtxt" style={{ fontSize: '32px' }}>{this.rb("banner.subheading1.za2")}</span>
					</h1> */}

					{this.getFaceBookEventUIWeb()}

					{(() => {

						if (!this.props.PLPloggedIn) {
							const styles = {
								margin: '0 auto'
							}

							return (

								<div className="col-12 nopadding mx-auto joingrp">
									<UserLoginType styles={styles} showSignUp={this.props.showSignUp} showNewLoginForm={this.props.showNewLoginForm} from={"Top"} />
									{/* <Whatsapp align="center" maxWidth="100%">/</Whatsapp> */}
								</div>

							);
						}
					})()}
				</div>
			</div >
		)
	}

	getFaceBookEventUIMob = () => {
		if (window.facebookEventAvailForNG) {
			return (
				<Fragment>
					<div className="heading-one robotospan headerpart2">
						<span className="txtcnt first-line">{this.rb("banner.subheading1.za5")}</span>
					</div>
					<div className="text-link text-center registerbtncontain" onClick={this.callregisterform}>
						<span className="txtcnt furtxt registerbtn" >{this.rb("banner.subheading1.za6")}</span>
					</div>
					<div className="heading-one robotospan headerpart3">
						<span className="txtcnt furtxt">{this.rb("banner.subheading1.za7")}</span>
						<img onClick={this.openpdfform} src="/img/facebook.png" alt="" />
					</div>
				</Fragment>
			)
		} else {
			return (
				<div className="heading-one robotospan" id="robotoheading" style={{ textAlign: 'center' }}>
					<span className="txtcnt first-line" style={{ fontSize: '24px' }}>{this.rb("banner.subheading1.ng3")}</span>
					<span className="txtcnt furtxt" style={{ fontSize: '24px' }}>{this.rb("banner.subheading1.ng4")}</span>
				</div>
			)
		}
	}

	homeformobile() {

		return (
			<div className="comp-inner">

				<div className="col-12 text-center b-comp">

					<div>
						<h1 className="heading-one" style={{ textAlign: 'center' }}>
							<span className="txtcnt first-line" style={{ fontSize: '32px' }}>{this.rb("banner.heading.ng2")}</span>
							<span className="txtcnt furtxt" style={{ fontSize: '32px' }}>{this.rb("banner.subheading.ng2")}</span>
						</h1>
						{/* <h1 className="heading-one" style={{ textAlign: 'center', marginBottom: '20px' }}>
							<span className="txtcnt furtxt" style={{ fontSize: '32px' }}>{this.rb("banner.subheading1.za2")}</span>
						</h1> */}

						{
							this.getFaceBookEventUIMob()
						}
					</div>


					{(() => {
						if (!this.props.PLPloggedIn) {
							return (
								<div className="col-12 nopadding mx-auto joingrp">
									<UserLoginType showSignUp={this.props.showSignUp} showNewLoginForm={this.props.showNewLoginForm} from={"Top"} />
									{/* <Whatsapp align="center" background={"#30BDBD"} maxWidth="100%">/</Whatsapp> */}
								</div>
							);
						}
					})()}
				</div>
			</div>
		)
	}

	homecomponent() {
		let addCls = this.props.addCls || '';
		if (this.isMobile() || this.isTab()) {
			return (
				<section className="h-mob-banner">
					<div className="swiper-container home-banner">
						{/*<Swiper className="swiper-wrapper" pagination={params.pagination}>*/}
						<div className="swiper-slide">
							<div className="container">
								{this.homeformobile()}
							</div>
						</div>

						{/*</Swiper>*/}
						<div className="swiper-pagination"></div>
					</div>
					<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='b-X5TsIQG24' onClose={() => this.setState({ isOpen: false })} />
				</section>
			)

		} else {
			return (
				<section className={"h-banner " + addCls}>
					<div className="swiper-container home-bannerweb">
						{/*<Swiper className="swiper-wrapper" pagination={params.pagination}>*/}
						<div className="swiper-slide">
							<div className="container">
								{this.homeforweb()}
							</div>
						</div>

						{/*</Swiper>*/}
						<div className="swiper-pagination"></div>
					</div>
					<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='b-X5TsIQG24' onClose={() => this.setState({ isOpen: false })} />
				</section>

			)
		}
	}

}


// WEBPACK FOOTER //
// ./src/views/ng/ng_Banner.js